<template>
  <div class="add-video-bg">
    <div class="add-video pl-4 pb-4 pt-3 pr-3">
      <span class="clearfix" style="cursor: pointer" @click="collapseModal"
        ><img src="../../assets/images/close-icon.svg"
      /></span>
      <b-button class="mr-2" variant="primary" size="lg" type="submit" id="checkbox" @click="hideAndShow('bulk')">{{ uploadType }}</b-button>
      <b-button class="mr-2" variant="primary" size="lg" type="submit" id="checkbox" @click="hideAndShow('move')">{{ moveType }}</b-button>
      <bulk-upload
        v-if="bulkUploadFlag"
      >
      </bulk-upload>
      <move-videos
        v-else-if="moveVideosFlag"
      >
      </move-videos>
      <form v-else class="pr-3 pt-1">
        <b-form-group
          label="YouTube Video Link"
          label-size="sm"
          label-class="form-label"
        >
          <b-form-input
            v-model="videoLink"
            class="embedId"
            required
            size="sm"
            trim
            ref="embedId"
            maxlength="50"
            :disabled="edit"
            placeholder="Please enter youtube video link"
          ></b-form-input>
        </b-form-group>
        <b-form-group>
          <b-row>
            <b-col>
              <b-form-input 
                v-model="startTime" 
                class="embedId" 
                type="text"
                size="sm"
                ref="startTime"
                required
                placeholder="Start Time">
              </b-form-input>
            </b-col>
            <b-col>
              <b-form-input  
                v-model="endTime" 
                size="sm"
                class="embedId" 
                type="text"
                ref="endTime"
                required
                placeholder="End Time">
              </b-form-input>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group label="Thumbnail" label-size="sm" label-class="form-label"
          ><b-row style="align-items: center">
            <b-col cols="4"
              ><b-form-checkbox
                id="thumbnail-check"
                v-model="thumbnailCheckStatus"
                name="checkbox-1"
                value="youtubeCheck"
                unchecked-value="s3Check"
                size="lg"
                label-class="thumbnail-label"
              >
                YouTube Thumbnail
              </b-form-checkbox></b-col
            ><b-col cols="5"
              ><b-form-input
                v-model="thumbnailTitle"
                required
                size="sm"
                trim
                disabled
                maxlength="50"
                placeholder="Upload thumbnail"
              ></b-form-input></b-col
            ><b-col cols="3">
              <b-button
                ref="thumbnailTitle"
                size="sm"
                class="custom-button select"
                :class="{
                  'custom-button-greyed':
                    thumbnailCheckStatus == 'youtubeCheck',
                }"
                @click="
                  $refs.thumbnail.$el.querySelector('input[type=file]').click()
                "
                ><p>SELECT</p></b-button
              ></b-col
            ></b-row
          >
          <b-form-file
            class="form___file"
            ref="thumbnail"
            v-model="thumbnail"
            :state="Boolean(thumbnail)"
            placeholder="Select Files"
            size="sm"
            accept="image/*"
            required
            @input="handleImageChange($event)"
          ></b-form-file>
        </b-form-group>
        <b-form-group
          label="Video Intensity"
          label-size="sm"
          label-class="form__label"
        >
          <b-row>
            <b-form-input
              id="range-1"
              v-model="videoIntensity"
              type="range"
              min="1"
              max="20"
              step="0.5"
              size="sm"
              ref="videoIntensity"
              class="intensity col-6 w-100 ml-6">
            </b-form-input>
            <div class="video-intensity-val d-flex p-1 col-3">
              <b-form-input
                class="col-4 mr-0"
                v-model="videoIntensity"
                size="sm"
                type="number"
              ></b-form-input>
            </div>
          </b-row>
        </b-form-group>
        <b-form-group label="Title" label-size="sm" label-class="form-label">
          <b-form-input
            v-model="title"
            required
            size="sm"
            ref="title"
            trim
            maxlength="100"
            placeholder="Please enter video title"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label="Select categories"
          label-size="sm"
          label-class="form-label"
          ><b-form-checkbox-group
            v-model="selectedCategory"
            class="video-category"
            :options="categoriesList"
            text-field="name"
            value-field="id"
            name="buttons-1"
            size="sm"
            buttons
            style="margin-top: -20px; height: 40px"
          ></b-form-checkbox-group>
        </b-form-group>
        <b-form-group
          label="Description"
          label-size="sm"
          label-class="form-label"
        >
          <b-form-textarea
            v-model="description"
            required
            size="sm"
            trim
            rows="3"
            ref="description"
            maxlength="200"
            no-resize
            placeholder="Your description will appear here..."
          ></b-form-textarea>
        </b-form-group>

        <b-form-checkbox
            id="create-baseline-check"
            v-model="createBaselineCheck"
            name="create-baseline-check-1"
            size="lg"
            label-class="create-baseline-label">
          Start baseline process
        </b-form-checkbox>

        <div
          class="custom-button upload-video"
          v-bind:class="{ 'custom-button-greyed': disableAddButton }"
          @click="uploadVideo"
        >
          <p>{{ edit ? "SAVE CHANGES" : "UPLOAD VIDEO" }}</p>
        </div>
        <b-alert
          show
          small
          variant="light"
          class="password-errors alert-ht font-green-16 p-2 mt-1 d-flex justify-content-center"
          :class="{ hide: hide }"
        >
          {{ errorMessage }}
        </b-alert>
      </form>
    </div>
    <loader v-if="addingVideo || updatingVideo || disableAddButton"></loader>
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers(
  "admin/trainerVideosView"
);

import S3Url from "../../s3upload/getSignedURL";
import EmbedID from "@/utils/youtubeEmbedID.js";
import {VIDEO_DATA} from "../../utils/constants";
import BulkUpload from "./BulkUpload.vue";
import MoveVideos from "./MoveVideos.vue";

export default {
  data: function () {
    return {
      uploadType: "Bulk Upload",
      moveType: "Deploy Videos",
      bulkUploadFlag: false,
      moveVideosFlag: false,
      embedId: null,
      title: null,
      description: null,
      thumbnailCheckStatus: "youtubeCheck",
      createBaselineCheck: false,
      thumbnail: null,
      videoIntensity: 1,
      thumbnailTitle: null,
      thumbnailURL: null,
      thumbnailFile: null,
      errorMessage: "",
      hide: true,
      edit: false,
      startTime: null,
      endTime: null,
      thumbnailChanged: false,
      videoLink: null,
      disableAddButton: false,
      selectedCategory: [],
      categoriesList:[],
      editCategoriesList: [],
      JsonVideoData: VIDEO_DATA,
    };
  },
  components: {
    BulkUpload,
    MoveVideos
  },
  props: {
    videoData: {
      type: Object,
    },
  },

  watch: {
    videoIntensity: function(val){
      if(+val < 1) this.videoIntensity = 1;
      else if(+val > 20) this.videoIntensity = 20;
    },
  },

  computed: {
    ...mapState(["addingVideo", "updatingVideo"]),
  },

  methods: {
    ...mapActions(["addVideo", "updateVideo", "getS3Cred", "loadVideos", "getCategories"]),

    collapseModal() {
      this.$emit("exit");
    },

    async categoriesAPIList(){
        const data = await this.getCategories();
        this.categoriesList = data;
    },

    toggleCategory(category) {
      if (!category.selected) category.selected = true;
      else category.selected = false;
      this.$log.info(this.categoriesList);
    },

    handleImageChange(e) {
      this.thumbnailChanged = true;
      this.thumbnailTitle = e.name;
      this.thumbnailFile = e;
      const reader = new FileReader();

      reader.onload = (e) => {
        this.thumbnail = e.target.result;
        this.thumbnailSrc =
          "data:image/jpeg;base64," +
          btoa(
            new Uint8Array(this.thumbnail).reduce(
              (data, byte) => data + String.fromCharCode(byte),
              ""
            )
          );
      };
      reader.readAsArrayBuffer(e);
    },

    /** 
     * Hide and show bulk Upload and move videos feature -----------START---------
     */
    async hideAndShow(value) {
      if (value === 'bulk') {
        this.moveVideosFlag = false;
        this.moveType = 'Deploy Videos';
        if (this.uploadType === 'Video Upload') {
          this.uploadType = 'Bulk Upload';
          this.bulkUploadFlag = false;
        }
        else {
          this.uploadType = 'Video Upload'
          this.bulkUploadFlag = true
        }
      }
      if (value === 'move') {
        if (this.moveType === 'Close'){
          this.moveVideosFlag = false;
          this.moveType = 'Deploy Videos';
        }
        else {
          this.bulkUploadFlag = false;
          this.moveVideosFlag = true;
          this.moveType = 'Close';
        }
      }
    },
    /** 
     * Hide and show bulk Upload and move videos feature -----------END------------
     */
    async uploadVideo() {
      this.errorMessage = "";
      this.hide = false;

      if (!this.videoLink) {
        this.errorMessage = "Please Enter YouTube Video Link";
        this.$refs.embedId.focus();
      } else if (
        this.thumbnailCheckStatus == "s3Check" &&
        !this.thumbnailTitle
      ) {
        this.errorMessage = "Please Select Thumbnail Image";
        this.$refs.thumbnailTitle.focus();
      } else if (!this.title) {
        this.errorMessage = "Please Enter Video Title";
        this.$refs.title.focus();
      } else if (!this.description) {
        this.errorMessage = "Please Enter Video Description";
        this.$refs.description.focus();
      } else if (!this.videoIntensity) {
        this.errorMessage = "Please Select Video Intensity";
        this.$refs.videoIntensity.focus();
      } else if (!this.startTime) {
        this.errorMessage = "Please Enter Start Time"
      } else if (!this.endTime) {
        this.errorMessage = "Please Enter End Time"
      }
      else {
        this.disableAddButton = true;
        this.hide = true;

        this.embedId = EmbedID.getEmbedID(this.videoLink);
        this.JsonVideoData.start= parseInt(this.startTime);
        this.JsonVideoData.end = parseInt(this.endTime);
        this.JsonVideoData.steps[0].start = parseInt(this.startTime);
        this.JsonVideoData.steps[0].end = parseInt(this.endTime);
        if (this.thumbnailCheckStatus == "s3Check" && this.thumbnailChanged) {
          await this.getS3Cred();
          let s3Cred = this.$store.state.admin.trainerVideosView.s3Cred;
          //upload thumbnail to s3
          let thumbResponse = await S3Url.getS3Url(
            s3Cred,
            this.thumbnailFile,
            this.thumbnail,
            "thumbnails"
          );
          this.thumbnailURL = thumbResponse.Location;
          this.thumbnailChanged = false;
        }

        if (this.thumbnailCheckStatus == "youtubeCheck") {
          this.thumbnailURL =
            "https://img.youtube.com/vi/" + this.embedId + "/sddefault.jpg";
        }
        let videoData = {
          embedId: this.embedId,
          title: this.title,
          description: this.description,
          category: this.selectedCategory,
          thumbnail: this.thumbnailURL,
          data: JSON.stringify(this.JsonVideoData),
          intensity: this.videoIntensity,
          createBaseline: this.createBaselineCheck,
          Date: new Date(),
        };

        if (this.edit) {
          videoData.id = this.videoData.id;
          videoData.isActive = this.videoData.isActive;
          videoData.isUpcoming = this.videoData.isUpcoming;

          const listOfCategory = this.editCategoriesList;
          let data = [];
          videoData.category.filter(function(o1){
            let obj = {};
            listOfCategory.some(function (o2) {
              if (o1 == o2.category_id) {
                obj.id = o2.id;
                obj.category_id = o1;
              }
            });
            if (Object.keys(obj).length) {
              data.push(obj);
            } else {
              obj.id = "";
              obj.category_id = o1;
              data.push(obj);
            }
          });
          videoData.category = data;
          await this.updateVideo({ vm: this, data: videoData });
          this.loadVideos();
        } else {
          await this.addVideo({ vm: this, data: videoData });
          this.loadVideos();
        }

        this.edit = false;
        this.collapseModal();
        this.disableAddButton = false;
      }
    },
  },
  mounted() {
    this.categoriesAPIList();
    this.edit = false;
    if (this.videoData.title) {
      this.edit = true;
      this.videoLink =
        "https://www.youtube.com/watch?v=" + this.videoData.embedId;
      this.videoIntensity = this.videoData.intensity == "Low" ? 3 : this.videoData.intensity == "Medium" ? 6 : this.videoData.intensity == "High" ? 9 : this.videoData.intensity;
      this.thumbnailURL = this.videoData.thumbnail;
      this.thumbnailTitle = this.videoData.thumbnail.substr(
        this.videoData.thumbnail.indexOf("/thumbnails/") + "/thumbnails/".length
      );
      this.editCategoriesList = this.videoData.categories;
      const catIds = this.videoData.categories.map(cat => cat.category_id);
      this.selectedCategory = catIds;
      this.title = this.videoData.title;
      this.description = this.videoData.description;
    }
  },
};
</script>
<style lang="scss" scoped>
.intensity {
  margin-left: 6%;
  margin-top: 1px;
}
.add-video-bg {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #ffff;
  background: rgba(35, 31, 32, 0.6);
}

.form-label {
  font-size: 18px;
  font-family: Kanit-Regular, Kanit;
  color: #bcbec0;
}

.video-category.btn-group-toggle {
  display: inline-block;
  height: auto !important;
  padding: 20px 0 0px 0;
}
.select {
  width: 80%;
  background-color: #73bc44;
  color: black;
}

.upload-video {
  background: transparent;
}
.upload-video:hover {
  background-color: #73bc44;
}
.custom-control-label {
  font-size: 18px !important;
  font-family: Kanit-Regular, Kanit !important;
  color: #bcbec0 !important;
}
select {
  background: #484848;
  font-size: 14px;
  color: #fff !important;
}
.custom-button-greyed {
  background: grey;
}

.custom-select {
  background-image: url("data:image/svg+xml;utf8,<svg fill='white' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
  background-repeat: no-repeat;
  background-position-x: 100%;
  background-position-y: 2px;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.custom-select::-ms-expand {
  display: none;
}

input,
textarea,
textarea:focus,
input:focus {
  background: transparent;
  color: #fff;
}

input:disabled {
  background-color: transparent;
  color: #fff;
}
input::placeholder,
textarea::placeholder {
  color: #fff;
}
.embedId:disabled {
  background-color: grey;
}

.add-video {
  position: absolute;
  left: 30%;
  top: 8%;
  width: 50%;
  height: 800px;
  z-index: 999;
  background-color: #5c6567;
  font-size: 36px;
  font-family: Kanit-Regular, Kanit;
  color: #bcbec0;
  span {
    img {
      height: 15px;
      width: 20px;
      float: right;
      cursor: pointer;
    }
  }
}

.form___file {
  display: none;
}
.hide {
  display: none !important;
}
.alert-ht {
  height: 35px;
  line-height: 15px;
}

.thumbnail-label {
  margin-top: 0.5rem;
}

@media screen and (max-width: 980px) and (min-width: 768px) {
  .custom-button {
    width: 70% !important;
    min-width: 60px !important;
    padding: 5px !important;
  }
}

.video-intensity-val {
  float: right;
  width: 48%;
  font-size: 12px;
  color: #73bc44;
  font-weight: bold;
  // text-align: end;
}
.video-intensity-val input[type="number"] {
  font-size: 12px;
  color: #73bc44;
  font-weight: bold;
  border: none;
  bottom: 6px;
  text-align: end;
}
.video-intensity-val input[type="number"]:focus {
  outline: none;
  border: none;
  // border-color: inherit;
  -webkit-box-shadow: none;
  box-shadow: none;
}

/* Chrome, Safari, Edge, Opera */
.video-intensity-val input::-webkit-outer-spin-button,
.video-intensity-val input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.video-intensity-val input[type="number"] {
  -moz-appearance: textfield;
}
</style>
